import { updateField } from 'vuex-map-fields';
import types from './mutations-types';

const mutations = {
  updateField,
  [types.SET_PANEL_INFO](state, payload) {
    state.panelsInfo = payload;
  },
  [types.SET_SHOW_CREATE_PANEL](state, payload) {
    state.showSidebar = payload;
  },
  [types.SET_PANEL_ID](state, payload) {
    state.idPanel = payload;
  },
  [types.SET_SHOW_EDIT_PANEL](state, payload) {
    state.showEditPanel = payload;
  },
  [types.SET_PANEL](state, payload) {
    state.panel = {
      ...state.panel,
      ...payload,
    };
  },
  // [types.SET_CARD_PANEL](state, payload) {
  //   state.panel = {
  //     ...state.panel,
  //     ...payload,
  //   };
  // },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/panels/mutations.js